import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

const QRScanner = ({ onScanSuccess, onScanError }) => {
  const [scannerId] = useState('qr-reader');

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      scannerId,
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        aspectRatio: 1.0,
      },
      false
    );

    const handleSuccess = (decodedText, decodedResult) => {
      console.log(`Scan result: ${decodedText}`, decodedResult);
      if (onScanSuccess) {
        onScanSuccess(decodedText, decodedResult);
      }
      scanner.clear();
    };

    const handleError = (errorMessage) => {
      if (onScanError) {
        onScanError(errorMessage);
      }
    };

    scanner.render(handleSuccess, handleError);

    return () => {
      scanner.clear().catch(error => {
        console.error("Failed to clear scanner:", error);
      });
    };
  }, [scannerId, onScanSuccess, onScanError]);

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div id={scannerId}></div>
    </div>
  );
};

export default QRScanner;
